<template>
  <div class="todo">
    <span class="date">{{ todo.created_at }}</span>&nbsp;
    <Badge v-if="badgeText" :text="badgeText" type="warning"></Badge>&nbsp;
    <a class="title" @click="showTodoDrawer = true">{{ todo.model.number }} {{ todo.title }}</a>

    <Drawer width="500" v-model="showTodoDrawer" :title="$t('task.task_info')">
      <Badge :text="getLabelFunc(todo.status)" :type="statusBadgeType[todo.status]"></Badge>&nbsp;
      <Badge v-if="badgeText" :text="badgeText" type="warning"></Badge>
      <h4>
        {{ todo.title }}
      </h4>
      <div class="content">
        <Icon type="md-warning" size="24" class="error" /><span class="warning">{{ $t('task.closure_notice') }}</span>
        <div style="margin-top: 35px;">
          <a @click="handleLinkClicked">>>> {{ $t('task.go_to_quote_page') }}</a>
        </div>
      </div>
      <div class="text-align-left">
        <Select @on-select="handleStatusSelected" v-model="todo.status" style="width: 120px">
          <Option v-for="opt in todoStatus" :key="opt.value" :value="opt.value">{{ $t(opt.label) }}</Option>
        </Select>
      </div>
      <div class="actions text-align-right">
        <Button type="text" @click="showTodoDrawer = false">Cancel</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Todo',
  props: {
    todo: Object,
    badgeText: String,
    onClick: Function,
    getLabelFunc: Function
  },
  data () {
    return {
      showTodoDrawer: false,
      saving: false,
      statusBadgeType: {
        0: 'info',
        1: 'success',
        2: 'normal'
      },
      todoStatus: [
        { label: 'open', value: 1 },
        { label: 'complete', value: 2 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'completeTodo',
      'updateTodo'
    ]),
    handleStatusSelected (selected) {
      this.saving = true
      this.updateTodo({ data: Object.assign({}, this.todo, { status: selected.value }), id: this.todo.id })
        .then((resp) => {
          this.$emit('update:todo', resp.data)
        })
        .finally(() => { this.saving = false })
    },
    handleLinkClicked () {
      let routeData = this.$router.resolve({ name: 'menu.quote.edit', params: { 'quoteId': this.todo.model_id } })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
